import { DisciplineLibrary } from "@/components/admin/DisciplineLibrary";

export function SettingsDisciplinesPage() {
  return <DisciplineLibrary />;
}
